import { type ReactElement } from 'react'
import { AccountStatusSelect, FormBlocker } from '@components'
import { useLoadedEntitlement } from '@front/model'
import { Group, Stack, TextInput } from '@mantine/core'
import { type ProgramId } from '@terros/common'
import { ProgramCompletionType } from './ProgramCompletionType'
import { ProgramScope } from './ProgramScope'
import { ProgramStartWeekday } from './ProgramStartWeekday'
import { ProgramStatusSelect } from './ProgramStatusSelect'
import { ProgramTriggerSelect } from './ProgramTrigger'
import { type WithProgramForm } from './type'

type Props = WithProgramForm & {
  programId?: ProgramId
  showStatus?: boolean
}

export const ProgramForm = ({ form, showStatus, programId }: Props): ReactElement => {
  const isRecruiting = useLoadedEntitlement('recruiting')
  return (
    <Stack>
      <FormBlocker form={form} />
      <TextInput required label='Name' {...form.getInputProps('name')} />
      <TextInput label='Description' {...form.getInputProps('description')} />
      <ProgramScope form={form} />
      {isRecruiting && (
        <Group>
          <AccountStatusSelect
            label='Initial Rep Journey Stage'
            description='When a rep is added to the program they will be moved to this stage'
            allowDeselect
            setStatusId={(statusId) => form.setFieldValue('fromStatusId', statusId)}
            statusId={form.values.fromStatusId}
            className='grow'
          />
          <AccountStatusSelect
            label='Rep Journey Stage'
            description='When a rep completes the program they will be moved to this stage'
            allowDeselect
            setStatusId={(statusId) => form.setFieldValue('accountStatusId', statusId)}
            statusId={form.values.accountStatusId}
            className='grow'
          />
        </Group>
      )}
      <ProgramTriggerSelect programId={programId} form={form} />
      <ProgramCompletionType form={form} />
      {form.values.completion === 'timeline' && <ProgramStartWeekday form={form} />}
      {showStatus && <ProgramStatusSelect form={form} />}
    </Stack>
  )
}
